import { TState } from 'redux/store'

export const confirmModalSelector = (state: TState) => state.common.confirmModal
